import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { colors } from '@chegg-ui/theme';
export var gridMaxWidth = 1200;
export var StyleThemeNames = ['mustard', 'sky', 'royal', 'teal', 'coral', 'orange', 'white', 'grey', 'greymedium', 'tealmedium', 'mustardmedium', 'coralmedium', 'royalmedium', 'skymedium', 'greylight', 'teallight', 'mustardlight', 'corallight', 'skylight', 'royallight', 'greyxlight', 'tealxlight', 'mustardxlight', 'coralxlight', 'skyxlight', 'royalxlight'];
var linkDefault = {
  linkColor: colors.link
};
var linkDark = {
  linkColor: colors.dark
};
var linkLight = {
  linkColor: colors.white
};

var commonProperties = _objectSpread({
  eyebrowColor: colors.cheggOrange,
  textColor: colors.dark,
  buttonTextColor: colors.white
}, linkDark);

export var themes = {
  orange: _objectSpread({
    eyebrowColor: colors.white,
    textColor: colors.white,
    backgroundColor: colors.cheggOrange,
    buttonTextColor: colors.dark
  }, linkLight),
  teal: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.white,
    backgroundColor: colors.teal,
    buttonTextColor: colors.white
  }, linkLight),
  mustard: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.dark,
    backgroundColor: colors.mustard,
    buttonTextColor: colors.white
  }, linkDark),
  coral: _objectSpread({
    eyebrowColor: colors.white,
    textColor: colors.white,
    backgroundColor: colors.coral,
    buttonTextColor: colors.dark
  }, linkLight),
  royal: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.white,
    backgroundColor: colors.royal,
    buttonTextColor: colors.white
  }, linkLight),
  sky: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.white,
    backgroundColor: colors.sky,
    buttonTextColor: colors.white
  }, linkLight),
  white: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.dark,
    backgroundColor: colors.white,
    buttonTextColor: colors.white
  }, linkDefault),
  grey: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.white,
    backgroundColor: colors.grey,
    buttonTextColor: colors.white
  }, linkLight),
  greymedium: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.white,
    backgroundColor: colors.greyMedium,
    buttonTextColor: colors.white
  }, linkLight),
  tealmedium: _objectSpread({
    backgroundColor: colors.tealMedium
  }, commonProperties),
  mustardmedium: _objectSpread({
    backgroundColor: colors.mustardMedium
  }, commonProperties),
  coralmedium: _objectSpread({
    backgroundColor: colors.coralMedium
  }, commonProperties),
  royalmedium: _objectSpread({
    backgroundColor: colors.royalMedium
  }, commonProperties),
  skymedium: _objectSpread({
    backgroundColor: colors.skyMedium
  }, commonProperties),
  greylight: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.dark,
    backgroundColor: colors.greyLight,
    buttonTextColor: colors.white
  }, linkDefault),
  teallight: _objectSpread({
    backgroundColor: colors.tealLight
  }, commonProperties),
  mustardlight: _objectSpread({
    backgroundColor: colors.mustardLight
  }, commonProperties),
  corallight: _objectSpread({
    backgroundColor: colors.coralLight
  }, commonProperties),
  royallight: _objectSpread({
    backgroundColor: colors.royalLight
  }, commonProperties),
  skylight: _objectSpread({
    backgroundColor: colors.skyLight
  }, commonProperties),
  greyxlight: _objectSpread({
    eyebrowColor: colors.cheggOrange,
    textColor: colors.dark,
    backgroundColor: colors.greyXlight,
    buttonTextColor: colors.white
  }, linkDefault),
  tealxlight: _objectSpread({
    backgroundColor: colors.tealXlight
  }, commonProperties),
  mustardxlight: _objectSpread({
    backgroundColor: colors.mustardXlight
  }, commonProperties),
  coralxlight: _objectSpread({
    backgroundColor: colors.coralXlight
  }, commonProperties),
  royalxlight: _objectSpread({
    backgroundColor: colors.royalXlight
  }, commonProperties),
  skyxlight: _objectSpread({
    backgroundColor: colors.skyXlight
  }, commonProperties)
};
Object.freeze(themes);